var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdsTimelineRejected(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.135 18.735C33.5499 17.1499 30.9801 17.1499 29.395 18.735L26.633 21.497C25.3825 22.7475 23.6865 23.45 21.918 23.45H17.3C16.1678 23.45 15.25 24.3678 15.25 25.5C15.25 26.6322 16.1678 27.55 17.3 27.55H23.0777C25.1537 27.55 27.1447 26.7253 28.6127 25.2573L35.135 18.735ZM46 25.5C46 28.3358 45.4619 31.0008 44.3856 33.495C43.3094 35.9892 41.8488 38.1588 40.0038 40.0038C38.1588 41.8488 35.9892 43.3094 33.495 44.3856C31.0008 45.4619 28.3358 46 25.5 46C22.6642 46 19.9992 45.4619 17.505 44.3856C15.0108 43.3094 12.8412 41.8488 10.9962 40.0038C9.15125 38.1588 7.69062 35.9892 6.61438 33.495C5.53813 31.0008 5 28.3358 5 25.5C5 22.6642 5.53813 19.9992 6.61438 17.505C7.69062 15.0108 9.15125 12.8412 10.9962 10.9962C12.8412 9.15125 15.0108 7.69063 17.505 6.61438C19.9992 5.53813 22.6642 5 25.5 5C28.3358 5 31.0008 5.53813 33.495 6.61438C35.9892 7.69063 38.1588 9.15125 40.0038 10.9962C41.8488 12.8412 43.3094 15.0108 44.3856 17.505C45.4619 19.9992 46 22.6642 46 25.5Z",
    fill: "#D44A3B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdsTimelineRejected);
export default __webpack_public_path__ + "static/media/ads-timeline-rejected.e303da1c5b82f7908c7ab46557fde5a7.svg";
export { ForwardRef as ReactComponent };